import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlHelperService {

  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public getUrlWithoutQueryStrings(url): string {
    const parser = this.renderer.createElement('a');
    parser.href = url;
    const urlToReturn = `${parser.protocol}//${parser.hostname}/${parser.pathname}`;
    parser.remove();
    return urlToReturn;
  }

  public getAuthorityUrlWithoutQueryStrings(url): string {
    const parser = this.renderer.createElement('a');
    parser.href = url;
    const urlToReturn = `${parser.protocol}//${parser.hostname}`;
    parser.remove();
    return urlToReturn;
  }

  public getHostName(url): string {
    const parser = this.renderer.createElement('a');
    parser.href = url;
    const urlToReturn = `${parser.hostname}`;
    parser.remove();
    return urlToReturn;
  }

  public getParamsFromUrl(url): Map<string, string> {
    const params = new Map<string, string>();
    const parser = this.renderer.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      params.set(pair[0], decodeURIComponent(pair[1]));
    }
    parser.remove();
    return params;
  }
}
